<template>
  <div class="department-info">
<!--    <yy-header>部门信息</yy-header>-->
    <div class="main">
<!--  placeName    -->
      <div class="department-name">{{this.placeName}}</div>
      <div class="group">
        <div class="label">工作时间</div>
<!--        workTime-->
        <div class="info">{{this.workTime}}</div>
      </div>
      <div class="group">
        <div class="label">地&nbsp;点</div>
<!--        placeAddress-->
        <div class="info">{{this.placeAddress}}</div>
      </div>
      <div class="group">
<!--        consaltPhone-->
        <div class="label">联系电话</div>
        <div class="info">{{this.consultPhone}}</div>
      </div>
      <div class="group">
<!--        www-->
        <div class="label">简&nbsp;介</div>
        <div class="info">{{this.description}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      windowId: '',
      placeId: '',
      placeName: '',
      workTime: '',
      placeAddress: '',
      description:'',
      consultPhone:'',
      app_token:''
    }
  },
  created () {
    this.getPlaceDetail();
  },
  methods: {
    async getPlaceDetail() {
      try {
        const res =  await this.$axios.post('/dev/AppFController/getPlaceDetailByPlaceIdOrWindowId', {
          windowId: this.windowId = this.$route.query.placeId
        })
        if (res.status === '200') {
          this.consultPhone = res.consultPhone
          this.area = res.area
          this.placeId = res.placeId
          this.placeName = res.placeName
          this.workTime = res.workTime
          this.placeAddress = res.placeAddress
          this.description = res.description
          this.organType = res.organType
        } else {
          this.$toast('该办理点暂不提供预约服务')
          this.finishedText = '该办理点暂不提供预约服务'
        }
      } catch (e) {
        this.$toast('获取办理点信息失败')
      }
    }
  }

}
</script>

<style lang='less' scoped>
.department-info {
  .main {
    margin-top: 0rem /* 110/50 */;
    padding: 0 .5rem /* 25/50 */;
    .department-name {
      color: rgba(0, 0, 0, 1);
      font-size: .76rem /* 38/50 */;
      font-weight: 700;
      line-height: 1;
      padding: .92rem /* 46/50 */ 0;
    }
    .group {
      display: flex;
      margin-bottom: .32rem /* 16/50 */;
      .label {
        width: 2.8rem /* 140/50 */;
        padding-right: .4rem /* 20/50 */;
        font-size: .56rem /* 28/50 */;
        color: #999;
        text-align: right;
      }
      .info {
        flex: 1;
        font-size: .56rem /* 28/50 */;
        color: #666;
      }
    }
  }
}
</style>
